import { render, staticRenderFns } from "./ModalConfiguracao.vue?vue&type=template&id=17473df3&scoped=true&"
import script from "./ModalConfiguracao.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracao.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17473df3",
  null
  
)

export default component.exports